// src/firebaseConfig.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  getFirestore,
} from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDNL7ZnSkji2qvCLw4qe6_vMwNKdNryWjg",
  authDomain: "avaliacao-fisica-ia.firebaseapp.com",
  projectId: "avaliacao-fisica-ia",
  storageBucket: "avaliacao-fisica-ia.firebasestorage.app",
  messagingSenderId: "78552772836",
  appId: "1:78552772836:web:32a517def4640fc2713cf1",
  measurementId: "G-26V2FE3E06",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// ── O CACHE PERSISTENTE PRECISA SER MULTI-ABA ───────────────────────────────
//
// `persistentLocalCache()` SEM `tabManager` não é "o padrão razoável": o SDK
// cai em `persistentSingleTabManager(undefined)` (conferido no fonte instalado,
// PersistentLocalCacheImpl), que exige acesso EXCLUSIVO ao IndexedDB. A segunda
// aba aberta no mesmo domínio não consegue a trava e o SDK cospe, em laço:
//
//   FIRESTORE (11.10.0) INTERNAL ASSERTION FAILED: Unexpected state (ID: b815)
//   CONTEXT: {"hc":"FirebaseError: Failed to obtain exclusive access to the
//   persistence layer…"}
//
// E não para no log: a falha da camada de persistência vira estado interno
// inconsistente, e é de lá que saem os `Uncaught` e os "Write stream transport
// errored. Name: undefined Message: undefined" que vinham logo atrás.
//
// No aplicativo isso nunca aparecia — WKWebView tem uma aba só. É defeito de
// WEB, e na web abrir o app em duas abas é o comportamento normal de qualquer
// pessoa.
//
// `persistentMultipleTabManager()` é a resposta que o próprio erro sugere: as
// abas passam a sincronizar consultas e escritas entre si, em vez de disputar
// uma trava.
//
// ── SOBRE O LONG POLLING ────────────────────────────────────────────────────
//
// `experimentalForceLongPolling` fica. Ele é o que faz o Firestore funcionar no
// WebView e atrás de proxy que não deixa passar stream, e o preço dele é
// justamente o que se vê no console do navegador: as requisições ao
// `/Write/channel` são longas, ficam ociosas e o browser as encerra
// (`ERR_QUIC_PROTOCOL_ERROR.QUIC_NETWORK_IDLE_TIMEOUT`, `ERR_ABORTED 400`). O
// SDK reconecta sozinho — é rotina do transporte, não defeito. Trocar por
// `experimentalAutoDetectLongPolling` calaria parte desse ruído e devolveria o
// risco que esta linha existe para evitar; não vale sem medir no aparelho.
let db;
try {
  db = initializeFirestore(app, {
    experimentalForceLongPolling: true,
    // `useFetchStreams` saiu: não existe mais na API do Firestore 11 (zero
    // ocorrências no index.d.ts do pacote instalado). Ficava aqui sendo ignorada
    // em silêncio e fazendo parecer que alguém tinha decidido alguma coisa.
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager(),
    }),
  });
} catch (err) {
  // Só cai aqui se o Firestore já tiver sido inicializado (HMR / import duplicado).
  // Qualquer outro erro é problema real de configuração e precisa aparecer.
  if (err?.code !== "failed-precondition") {
    console.error("[firebaseConfig] initializeFirestore falhou:", err);
  }
  db = getFirestore(app);
}

const auth = getAuth(app);
const functions = getFunctions(app, "southamerica-east1");

export { app, auth, db, functions };
